import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

const ToggleContainer = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
  cursor: pointer;
`

const ToggleInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: #000;
  }

  &:checked + span:before {
    transform: translateX(20px);
  }
`

const Slider = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d1d1;
  transition: 0.3s;
  border-radius: 28px;

  &:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`

const ToggleSlider = ({ checked, onChange, ...props }) => {
  return (
    <ToggleContainer>
      <ToggleInput
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <Slider />
    </ToggleContainer>
  )
}

ToggleSlider.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ToggleSlider
